const NeedsUpgradeReason = {
	RENEW: 'renew',
	MAX_FREE_ITEMS_REACHED: 'max_free_items_reached',
	MAX_FREE_BOARDS_REACHED: 'max_free_boards_reached',
} as const;

export default NeedsUpgradeReason;
